import React from "react";
import NumericText from "ui/NumericText";

export function NumberQuestionRender({
  is_required,
  isOfficeUse,
  label,
  readonly,
  willShowNotAllowedCursor,
  value,
  handleChange,
  hasError,
  errorMessage,
  ...props
}) {
  return (
    <div>
      <NumericText
        disabled={readonly}
        errorLabel={errorMessage}
        hasError={hasError}
        isOfficeUse={isOfficeUse}
        isRequired={is_required}
        label={label}
        onChange={handleChange}
        value={value}
        willShowNotAllowedCursor={willShowNotAllowedCursor}
        {...props}
      />
    </div>
  );
}

export default NumberQuestionRender;
